import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("rect", { x: "1.5", y: "1.5", width: "21", height: "21", rx: "10.5", fill: "transparent" }));
export default createSvgIcon(iconPath, "RadioButtonUnchecked");
//# sourceMappingURL=RadioButtonUncheckedIcon.js.map